import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retried && !orig.url?.includes("/auth/")) {
      orig._retried = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch (e) {
        /* fall through */
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err, fallback = "Något gick fel. Försök igen.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || fallback;
}
